import {PageContainerSkeleton, TableSkeleton, ToolbarSkeleton} from "@project/components/feedback";
import {Skeleton} from "@project/design-system-web";

export function OfferEditorPending() {
  return (
    <PageContainerSkeleton>
      <ToolbarSkeleton>
        <ToolbarSkeleton.Button />
      </ToolbarSkeleton>
      <div className="grid min-h-0 flex-1 gap-4 @4xl:grid-cols-2">
        <div className="flex min-h-0 flex-col gap-4">
          <div className="grid grid-cols-2 gap-4">
            <Skeleton className="h-24 rounded-xl" />
            <Skeleton className="h-24 rounded-xl" />
          </div>
          <TableSkeleton columns={6} rows={5} />
        </div>
        <Skeleton className="h-full min-h-75 rounded-xl" />
      </div>
    </PageContainerSkeleton>
  );
}
